import { IOffStreetParkingSummary } from "@/types";
import { ColumnDef } from "@tanstack/react-table";
import { ArrowUpDownIcon } from "components/icons";
import { Button } from "@/components/ui/button";

export const columns: ColumnDef<IOffStreetParkingSummary>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => {
      return (
        <Button
          className="text-[#8E8E96] ml-[-10px] rounded-md"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nom
          <ArrowUpDownIcon />
        </Button>
      );
    },
  },
];
